<template>
  <div class="GlowMenu" :style="mystyle">
    <div class="dragMenu"><slot></slot></div>
    <glowBtn  v-for="(item,i) in values" :key="i" :item="item" :state="getState(i)" @click.native="itemClick(i)">{{item.name}}</glowBtn>
  </div> 
</template>

<script>
import glowBtn from "@/components/glowBtn.vue";
export default {
  components: {
    glowBtn
  },
  props: {
    allowToggle:{
      default:true
    },
    values: null,
  },
  data() {
    return {
      menuIndex:null
    };
  },
  computed: {
    currentItem(){
      if(this.values){
        return this.values[this.menuIndex]
      }
    },
    itemCont() {
      return { state: true };
    },
    mystyle() {
      return "width:" + this.width + "px;";
    }
  },
    methods: {
      getIndex(){
        return this.menuIndex
      },
      getState(index){
        return index == this.menuIndex
      },
      itemClick(index) {
        if (index==this.menuIndex && this.allowToggle) {
        this.menuIndex=null
      }else if (index!=null) {
        this.menuIndex=index
      }
      this.$emit('menuChange',this.menuIndex)
     
    }
  },
};
</script>

<style scoped>
.dragMenu{
  cursor:move;
}
.GlowMenu {
  
  line-height: 30px;
}
</style>